<template>
  <section class="home">
    <article class="home-info">
      <div class="home-info-swiper">
        <el-carousel v-if="isPerfectMessage == 0" loop>
          <el-carousel-item v-for="item in swiperList" :key="item.id">
            <img class="img" :src="item.url" alt />
          </el-carousel-item>
        </el-carousel>
        <div class="home-info-message" v-if="isPerfectMessage == 1">
          <div class="Content">
            <h3 class="title">完善信息</h3>
            <div class="input">
              <el-input v-model="orgName" placeholder="单位名称"></el-input>
            </div>
            <div class="input">
              <el-input
                v-model="orgNumber"
                placeholder="社会统一信用代码"
              ></el-input>
            </div>
            <div class="input">
              <el-button type="primary" @click="saveMessage">保存</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="home-info-detail">
        <h3 class="title">会员信息</h3>
        <p>手机号码：{{ sysUserVo.userPhone }}</p>
        <div v-show="sysUserVo.orgName != null && sysUserVo.orgName != ''">
          <p>单位名称:{{ sysUserVo.orgName ? sysUserVo.orgName : "无" }}</p>
          <p>
            社会统一信用代码：{{
              sysUserVo.orgNumber ? sysUserVo.orgNumber : "无"
            }}
          </p>

          <p v-show="sysUserVo.ukeyBind == null">
            您还未绑定CA证书，
            <span class="toBind" @click="getUkeyId">去绑定</span>
          </p>
          <p v-if="sysUserVo.ukeyBind != null">
            数字证书唯一标识:
            <span  >{{ sysUserVo.ukeyBind.ueyNumber }}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="toBind" @click="getUkeyId">重新绑定</span>
          </p>
           <p v-if="sysUserVo.ukeyBind != null">
            电子签章过期时间:
            <span   v-html="timestampToTime(sysUserVo.ukeyBind.exTime)"> </span>
          </p>
          <div>
            <p
              v-for="item in sysUserVo.memberPowerVos"
              :key="item.powerTypeCode"
            >
              <span v-if="(item.powerTypeCode = 'cshy')"
                >会员类型：测试会员 &nbsp;&nbsp;有效期:<span
                  v-html="timestampToTime(item.exTime)"
                >
                </span
              ></span>
            </p>
          </div>
        </div>
        <div
          v-show="sysUserVo.orgName == null || sysUserVo.orgName == ''"
          style="text-align: left; margin-top: 10px"
        >
          <p>
            您现在还未完善会员信息，请尽快完善。
            <a style="color: blue" @click="perfectMessage">去完善</a>
          </p>
        </div>
      </div>
    </article>
    <article class="home-tip">
      <div class="home-tip-content">
        <span>温馨提示：</span>
        <span
          >客服电话：02882128508 转 812、814、816
          （法定工作日9:00至17:30请拨打座机 ）,紧急联系电话：19302849535
          （非上班时间仅处理紧急事务）。</span
        >
      </div>
    </article>
  </section>
</template>

<script>
import {
  getSysUser,
  saveUserOrg,
  bidCert,
  bindCA,
  getCert,
  getUkeyId,
} from "@/api";

export default {
  name: "HomeView",
  data() {
    return {
      password: "",
      UkeyBind: {
        ueyNumber: "",
        ukeyInfo: "",
        certInfo: "",
        exTime: null,
      },
      swiperList: [
        {
          id: 1,
          url: "https://mem.bossbolo.com/img/1.png",
        },
        {
          id: 2,
          url: "https://mem.bossbolo.com/img/2.jpg",
        },
        {
          id: 3,
          url: "https://mem.bossbolo.com/img/3.jpg",
        },
        {
          id: 4,
          url: "https://mem.bossbolo.com/img/4.png",
        },
      ],
      sysUserVo: {},
      orgName: "",
      orgNumber: "",
      isPerfectMessage: 0,
    };
  },
  mounted() {
    localStorage.setItem("token", this.$route.query.token);
    this.getData();
  },
  methods: {
    timestampToTime(timestamp) {

      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    bindCA() {
      bindCA(this.UkeyBind).then((res) => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
        } else {
          this.$message.error(res.msg);
        }
        this.getData();
      });
    },
    getData() {
      getSysUser().then((res) => {
        console.log(res);
        this.sysUserVo = res.data;
        this.isPerfectMessage = 0;
      });
      /* FormData 请求方式
      let p = new FormData()
      p.append('user', '123')
      p.append('id', '123')
        this.sysUserVo = res.data
      })*/
    },
    open() {
      this.$prompt("请输入ukey密码", "证书绑定", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      inputType:"password",
        inputValidator(value) {
          if (value == undefined) {
            return "ukey密码为空";
          }
        },
      })
        .then(({ value }) => {
          this.password = value;
          this.bidCert1();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消绑定",
          });
        });
    },
    callBack(state, data) {
      console.log(data);
      if (state == 0) {
        if (data.readyState == 0)
          this.$message.error("绑定失败,请检查签章助手是否安装并且启动程序");
        else if (data.readyState == 4) {
          this.$message.error("绑定失败,ukey密码错误");
        }
      } else if (state == 1) {
        if (data.userNumber != this.sysUserVo.orgNumber) {
          this.$message.error(
            "绑定失败,单位不一致!" + data.userNumber + "(证书)"
          );
          return;
        } else {
          this.UkeyBind.ukeyInfo = JSON.stringify(data);
          this.UkeyBind.exTime = data.validityEndTime;
          //获取证书
          this.getCert();
        }
      }
      console.log(data);
    },
    getUkeyIdCallback(state, data) {
      if (state == 1) {
        if (data.success) {
          this.UkeyBind.ueyNumber = data.data;
          this.open();
        }
      } else {
        if (data.readyState == 0)
          this.$message.error("请检查签章助手是否安装并且启动程序");
        else if (data.readyState == 4) {
          this.$message.error("获取证书信息失败");
        }
      }
    },
    //获取ukey
    getUkeyId() {
      getUkeyId(this.getUkeyIdCallback);
    },
    //获取证书信息
    getCert() {
      getCert({ pin: this.password, type: 1 }, this.getCertCallBack);
    },
    getCertCallBack(state, data) {
      console.log(state + data);
      if (state == 1 && data.success) {
        this.UkeyBind.certInfo = data.data;
        console.log("证书信息：" + JSON.stringify(this.UkeyBind));
        this.bindCA();
      } else {
        this.$message.error("获取证书信息失败");
      }
    },
    bidCert1() {
      //  let p = {ping:'1234',type:1}
      bidCert(this.password, this.callBack);
    },

    perfectMessage() {
      this.isPerfectMessage = 1;
    },
    saveMessage() {
      this.$confirm(
        "单位名称:" + this.orgName + ";统一社会信用代码:" + this.orgNumber,
        "确定单位信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          //确认
          let p = new FormData();
          p.append("orgName", this.orgName);
          p.append("orgNumber", this.orgNumber);
          saveUserOrg(p).then((res) => {
            this.getData();
          });
        })
        .catch(() => {
          //取消
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 20px;

  &-info {
    display: flex;
    justify-content: space-between;
    height: 400px;

    &-swiper {
      width: 68%;
      height: 100%;

      .el-carousel {
        height: 100%;

        :deep(.el-carousel__container) {
          height: 100%;
          .el-carousel__arrow {
            background-color: rgba(31, 45, 61, 0.6);
          }
        }

        .el-carousel__item {
          height: 100%;
          .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 10px;
          }
        }
      }
    }
    &-message {
      width: 70%;
      height: 100%;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      margin: 0px auto;
      .Content {
        width: 400px;
        margin: 0px auto;
      }
      .title {
        font-size: 16px;
        font-weight: 600;
        padding: 10px;
        margin: 0;
        border-bottom: 1px solid #eee;
      }
      .input {
        text-align: center;
        padding: 10px;
        margin-top: 30px;
      }
    }
    &-detail {
      width: 30%;
      height: 100%;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

      .title {
        font-size: 16px;
        font-weight: 600;
        padding: 10px;
        margin: 0;
        border-bottom: 1px solid #eee;
      }

      p {
        padding: 20px 10px 0;
        margin: 0;

        opacity: 0.75;
        text-align: left;
      }

      .bindCertificate {
        margin-top: 30px;
        padding: 10px;
        text-align: left;
      }
      .toBind {
        color: #409eff;
        cursor: pointer;
      }
    }
  }

  &-tip {
    margin-top: 10px;
    height: 100%;
    background-color: #ff000030;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 20px;

    &-content {
      font-size: 14px;
      opacity: 0.75;
      text-align: left;
      color: #17426d;

      span {
        font-weight: 600;
      }

      p {
        margin: 0;
        padding: 10px 0;
      }
    }
  }
}
</style>
